import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, consultaCpf } from './types';

export const INITIAL_STATE: consultaCpf = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): consultaCpf {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_CPF_AAC_REQUEST: {
				break;
			}

			case Types.CONSULTA_CPF_AAC_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.CONSULTA_CPF_AAC_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTA_CPF_AAC_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
